import { useIntl } from 'react-intl';
import { Icon, Tooltip } from '@ets/design-system';

import { useSelector } from '_common/hooks';

import IEnvisionLog from './logo.svg';

import { selectIsIEnvision } from 'App/redux/appSlice';
import cn from 'classnames';

const IntegrationiEnvisionLogo = () => {
  const intl = useIntl();
  const isiEnvision = useSelector(selectIsIEnvision);
  const extra = useSelector((state) => state.app.information.extra);
  const isEditor = useSelector((state) => state.editor.status.visible);

  if (!isiEnvision) {
    return null;
  }

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'GO_BACK_TO_IENVISON' })}
      testId="go-back-to-ienvision"
      placement="bottom"
    >
      <div
        data-testid="integration-ienvision-logo"
        className={cn('ml-auto flex shrink-0 cursor-pointer items-center', { 'mr-4': !isEditor })}
        onClick={() => {
          if (extra) {
            window.location.href = `${extra.source}`;
          }
        }}
      >
        <Icon size="2" icon="chevron-left" testId="go-back-to-ienvision" />
        <img src={IEnvisionLog} alt="iEnvision logo" />
      </div>
    </Tooltip>
  );
};

export default IntegrationiEnvisionLogo;
